import React, { Component } from "react";

/**
 * Floating "Get a Quote" pill that fades in after the user scrolls 400px.
 * Hidden on pages where the booking form is already above the fold:
 * /, /quote, /book, /bakkie-hire, /truck-hire, /partner-drivers, /track-order
 */
const HIDE_ON = ["/", "/quote", "/book", "/book-a-truck", "/instant-quote",
  "/get-quote", "/bakkie-hire", "/truck-hire", "/partner-drivers",
  "/track-order", "/register-your-vehicle", "/chat"];

class FloatingQuoteCTA extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    this.setState({ visible: window.scrollY > 400 });
  };

  render() {
    const path = window.location.pathname;
    if (HIDE_ON.some((p) => path === p || path.startsWith(p + "?"))) return null;

    return (
      <a
        href="/quote"
        className={`floating-quote-cta${this.state.visible ? " floating-quote-cta--visible" : ""}`}
        aria-label="Get an instant quote"
      >
        <i className="mdi mdi-truck-fast floating-quote-icon" />
        <span>Get a Quote</span>
      </a>
    );
  }
}

export default FloatingQuoteCTA;
